export default {
    common: {
        loading: "Cargando…",
        back: "Volver",
        save: "Guardar",
        cancel: "Cancelar",
        close: "Cerrar",
        viewAll: "Ver todo",
    },
    nav: {
        home: "Inicio",
        shop: "Tienda",
        bulkQuote: "Cotización volumen",
        faq: "FAQ",
        research: "Investigación",
        about: "Nosotros",
        contact: "Contacto",
    },
    header: {
        signIn: "Iniciar sesión",
        account: "Cuenta",
        admin: "Admin",
        logout: "Cerrar sesión",
        openCart: "Abrir carrito",
        menu: "Menú",
        language: "Idioma",
    },
    footer: {
        disclaimerTitle: "Sólo para uso investigativo.",
        disclaimer:
            "Todos los péptidos listados en este sitio se venden estrictamente con fines de investigación de laboratorio in-vitro y no son aptos para el consumo humano o veterinario. No están destinados a diagnosticar, tratar, curar o prevenir ninguna enfermedad y no deben ser ingeridos, inyectados, aplicados ni consumidos por humanos o animales.",
        readFullDisclaimer: "Leer el descargo completo →",
        tagline:
            "Péptidos de investigación de alta pureza, sintetizados en nuestro laboratorio asociado. Sólo para uso de laboratorio e investigación. No apto para consumo humano.",
        purityBadge: "Pureza verificada ≥99% · probado por HPLC",
        company: "Empresa",
        legal: "Legal",
        about: "Nosotros",
        research: "Investigación",
        shop: "Tienda",
        contact: "Contacto",
        bulkQuote: "Cotización volumen",
        trackOrder: "Rastrear pedido",
        faq: "FAQ",
        privacy: "Política de privacidad",
        gdpr: "Política RGPD",
        cookies: "Política de cookies",
        terms: "Términos y condiciones",
        complaints: "Procedimiento de reclamaciones",
        copyright: "© {{year}} Nexus Peptides. Todos los derechos reservados.",
        status: "SYS.ESTADO / EN LÍNEA · CRIO.BAY / 02 · LOTE.OK",
    },
    hero: {
        badge: "Grado de investigación · ≥99% verificado por HPLC",
        headlineLine1: "El filo",
        headlineLine2: "molecular de la",
        headlineAccent: "investigación",
        headlineLine3: "moderna.",
        body:
            "Péptidos de alta pureza sintetizados en nuestro laboratorio asociado, verificados por HPLC y espectrometría de masas de terceros. Diseñados para laboratorios que no transigen con la integridad de los datos.",
        searchLabel: "Búsqueda de productos",
        searchPlaceholder: "Busca entre 50+ péptidos por nombre o función…",
        searchButton: "Buscar",
        exploreCatalog: "Explorar catálogo",
        viewResearch: "Ver investigación",
        statPurity: "Pureza HPLC",
        statCompounds: "compuestos",
        statColdChain: "cadena fría",
        dragHint: "ARRASTRA · GIRA · EXPLORA",
        tickerGuideLabel: "GRATIS: GUÍA NEXUS PEPTIDES 101 — DESCARGAR PDF",
        sectionCatalog: "// Catálogo · 01",
        signature: "Compuestos destacados",
        viewFullCatalog: "Ver catálogo completo",
        sectionMethod: "// Método · 02",
        methodHeading1: "Diseñado para",
        methodHeading2: "datos en los que",
        methodAccent: "confiar",
        methodBody:
            "Cada lote pasa un protocolo de control de calidad de 6 etapas en nuestro laboratorio asociado. Desde la síntesis de aminoácidos hasta HPLC, LC-MS y ensayos microbianos — publican los datos para que los tuyos tengan base.",
        partnerLabSpec: "Especificaciones del laboratorio asociado",
        partnerLabSpecCaption: "Verificado por HPLC y espectrometría de masas de terceros por lote",
        ctaEyebrow: "// Listo para investigar",
        ctaHeading: "Obtén los compuestos que tu protocolo merece.",
        ctaBrowse: "Ver catálogo",
        ctaBulk: "Consulta por volumen",
    },
    chat: {
        title: "Nexus conserje",
        online: "En línea · Respuesta instantánea",
        toggle: "Abrir chat",
        send: "Enviar",
        placeholder: "Pregunta por un compuesto, COA, plazo…",
        disclaimer: "Asistente IA · solo uso investigativo",
        fallbackGreeting: "Hola — ¿en qué compuesto o pedido puedo ayudarte?",
        rateLimited: "Has alcanzado el límite diario de chat. Inténtalo mañana o usa 'Hablar con humano' abajo.",
        errorGeneric: "El asistente no está disponible temporalmente. Inténtalo de nuevo en un momento.",
        back: "Volver",
        askHuman: "Hablar con humano",
        startersEyebrow: "Preguntas rápidas",
        starters: {
            bulkPricing: {
                label: "Precios por volumen",
                hint: "Descuentos y cuentas institucionales",
                prompt: "¿Cuáles son sus descuentos por volumen para un pedido grande?",
            },
            leadTimes: {
                label: "Plazos",
                hint: "Estándar, prioritario y a medida",
                prompt: "¿Cuáles son sus plazos habituales para pedidos estándar y prioritarios?",
            },
            coas: {
                label: "COAs",
                hint: "Certificado de análisis por lote",
                prompt: "¿Cómo obtengo un Certificado de Análisis para un producto que voy a pedir?",
            },
        },
        handoffTitle: "Hablar con humano",
        handoffSubtitle: "Respondemos en 1 día laborable",
        handoffIntro: "Deja tu email y una breve nota — un humano de nuestro equipo responderá con toda la transcripción del chat adjunta.",
        handoffEmail: "Email profesional *",
        handoffName: "Tu nombre (opcional)",
        handoffNote: "¿Algo específico que quieras que respondamos? (opcional)",
        handoffSubmit: "Enviar al equipo",
        handoffSending: "Enviando…",
        handoffDone: "Enviado — hablamos pronto",
        handoffDoneBody: "Responderemos a tu email en un día laborable.",
        handoffFooter: "La transcripción del chat se adjuntará automáticamente.",
        handoffError: "No se pudo enviar. Inténtalo de nuevo en un momento.",
    },

    loyalty: {
        eyebrow: "// Programa de fidelidad",
        pts: "pts",
        worth: "Vale £{{amount}} en el checkout",
        hint: "Gana {{earn}} puntos por cada £1 gastado. {{value}}p por punto al canjear. Hasta {{pct}}% de descuento por pedido.",
        redeemLabel: "Canjear puntos",
        redeemHint: "Tienes {{balance}} pts · máx {{max}} en este pedido (tope {{pct}}%)",
        redeemNone: "Ninguno",
        redeemMax: "Máximo",
        rowLabel: "Canje fidelidad ({{pts}} pts)",
        earnMultiplier: "tasa de puntos",
        progressTo: "Progreso a {{label}}",
        perks: {
            bronze: "",
            silver: "Perk Silver: envío UK gratuito en cada pedido",
            gold: "Perks Gold: envío UK + UE gratuito + 1.25× puntos",
            platinum: "Perks Platinum: envío mundial gratuito + 1.5× puntos",
        },
    },

    process: {
        synthesis: {
            title: "Síntesis en fase sólida",
            desc: "Protocolo Merrifield con protección Fmoc en sintetizadores automáticos.",
        },
        hplc: {
            title: "HPLC + LC-MS",
            desc: "HPLC de fase inversa a 220 nm y 280 nm; masa confirmada con precisión ±1 Da.",
        },
        screening: {
            title: "Cribado microbiano",
            desc: "Cribado de endotoxinas y biocarga por cada lote.",
        },
        coldchain: {
            title: "Logística de cadena fría",
            desc: "Almacenamiento liofilizado a −20°C; contenedores térmicos aislados.",
        },
    },
    shop: {
        eyebrow: "// El catálogo",
        title: "Compuestos de investigación",
        intro:
            "Cada vial respaldado por un Certificado de Análisis. Filtra por categoría o explora la biblioteca completa. Todos los productos se envían liofilizados en viales de borosilicato de 10 ml con tapón de goma.",
        searchLabel: "Búsqueda de productos",
        searchPlaceholder: "Busca péptidos por nombre, categoría o función…",
        clear: "Limpiar",
        filterAll: "Todos",
        resultsCount: "Mostrando {{count}} de {{total}} compuestos{{queryPart}}",
        resultsQueryPart: " que coinciden con «{{query}}»",
        loading: "Cargando catálogo…",
        noMatchesTitle: "Sin resultados",
        noMatchesBody: "No se encontró nada para «{{query}}» en {{where}}.",
        noMatchesWhereAll: "el catálogo",
        resetFilters: "Reiniciar filtros",
        requestTitle: "¿No encuentra lo que necesita?",
        requestBody: "Nuestro catálogo está curado, pero podemos conseguir casi cualquier péptido de investigación bajo pedido. Díganos qué está buscando.",
        requestCta: "Solicitar un péptido",
    },
    product: {
        purity: "Pureza",
        labPick: "Destacado",
        penBadge: "Formato pluma",
        from: "desde",
        add: "Añadir",
        whatItDoes: "Qué hace",
        selectSize: "Selecciona tamaño",
        availableSizes: "Tamaños disponibles",
        addToCart: "Añadir",
        researchAdvisory: "Aviso de investigación",
        doses: "Dosis",
        sizes: "{{count}} tamaños",
        classLabel: "Categoría",
        hplc: "HPLC",
        perVial: "/ vial",
        vialOf: "vial de {{dose}}",
        tabOverview: "Resumen",
        tabSpecs: "Especificaciones",
        tabStorage: "Almacenamiento",
        highlights: "Aspectos destacados",
        sequence: "Secuencia",
        molecularWeight: "Peso molecular",
        format: "Formato",
        storageBody:
            "Tras reconstituir con agua bacteriostática, conservar entre 2–8°C y usar en un plazo de 14 días. Evita ciclos repetidos de congelación-descongelación. Sólo para investigación in-vitro, no apto para uso humano o veterinario.",
        crumbHome: "Inicio",
        crumbShop: "Tienda",
        notFound: "Producto no encontrado",
        backToShop: "← Volver a la tienda",
        coaAvailable: "COA disponible",
        downloadCoa: "Descargar COA (PDF)",
        coldChain: "Cadena fría",
        researchOnly: "Sólo investigación",
        viewPhoto: "Foto",
        view3D: "Modelo 3D",
        residues: "residuos",
        dragRotate: "Arrastrar · rotar",
        structureUnavailableEyebrow: "Estructura no disponible",
        structureUnavailableTitle: "Modelo 3D no disponible para este compuesto",
        structureUnavailableBody: "Este compuesto no tiene una secuencia peptídica que podamos renderizar en 3D. Vuelve a la vista de foto para ver la imagen del producto.",
    },
    cart: {
        eyebrow: "Tu carrito",
        countOne: "1 artículo",
        countOther: "{{count}} artículos",
        emptyTitle: "Vacío",
        emptyBody: "Aún no hay compuestos en tu carrito.",
        each: "c/u",
        subtotal: "Subtotal",
        bundleApplied: "Pack −{{pct}}%",
        bundleNudge: "Añade 1 más para −{{pct}}%",
        bundleSavings: "Ahorro por pack",
        freeShipping: "Envío gratuito desbloqueado",
        towardFreeShipping: "Te faltan £{{amount}} para el envío gratis",
        tierCountdown: "Te faltan {{points}} pts para {{tier}}",
        tierTopReached: "Has alcanzado {{tier}} — nuestro nivel máximo",
        checkout: "Finalizar compra →",
        keepBrowsing: "Seguir comprando",
        requestBulkQuote: "Solicitar cotización por volumen",
        remove: "Eliminar",
    },
    checkout: {
        eyebrow: "// Pago seguro",
        title: "Finalizar pedido",
        sectionShipping: "Datos de envío",
        sectionPayment: "Pago",
        demoMode: "Modo demo",
        demoNote:
            "Esta es una pasarela de pago simulada. No se cobrará ninguna tarjeta. Usa cualquier número de 16 dígitos para probar (p. ej. 4242 4242 4242 4242).",
        fullName: "Nombre completo",
        email: "Email",
        address: "Dirección",
        city: "Ciudad",
        state: "Provincia",
        zip: "Código postal",
        country: "País",
        phone: "Teléfono",
        cardNumber: "Número de tarjeta",
        expiry: "Caducidad (MM/AA)",
        cvc: "CVC",
        summaryEyebrow: "// Resumen del pedido",
        sumBundle: "Total del carrito",
        sumBundleSavings: "Descuento por pack",
        sumSubtotal: "Subtotal",
        sumShipping: "Envío",
        sumShippingFree: "Gratis",
        shipPolicyLabel: "Envío:",
        shipPolicyBody: "Envío gratuito a todo el mundo en pedidos superiores a £{{threshold}}. Por debajo: £15 Reino Unido · £20 UE · £30 resto del mundo.",
        shipAwayFromFree: "£{{amount}} más para envío gratis",
        sumTax: "Impuestos (est.)",
        sumTotal: "Total",
        place: "Realizar pedido",
        placing: "Procesando…",
        secureNote: "Cifrado de 256 bits · sólo demo",
        emptyTitle: "Carrito vacío",
        emptyBody: "Añade un compuesto para iniciar el pago.",
        browseCatalog: "Ver catálogo",
        qty: "Cant. {{n}}",
    },
    shipBanner: {
        free: "Envío gratuito a todo el mundo en pedidos superiores a £150",
        regions: "£15 Reino Unido · £20 UE · £30 Resto del mundo",
        request: "¿No encuentra un péptido? Solicítelo — obtenemos casi todo",
        progress: "Te faltan £{{amount}} para envío gratuito en UK",
        earned: "Envío gratuito en UK desbloqueado",
    },
    order: {
        confirmedEyebrow: "// Confirmado",
        title: "Pedido realizado",
        reference: "Referencia",
        shippingTo: "Envío a",
        payment: "Pago",
        status: "Estado",
        subtotal: "Subtotal",
        shipping: "Envío",
        shippingFree: "Gratis",
        tax: "Impuestos",
        totalPaid: "Total pagado",
        coldChainTitle: "Despacho en cadena fría en 24h",
        coldChainBody:
            "Tu pedido se envía en embalaje térmico aislado desde nuestra cámara criogénica a −20°C. Recibirás un número de seguimiento por email en menos de 24 horas.",
        continueBrowsing: "Seguir explorando",
        viewMyOrders: "Ver mis pedidos",
        each: "c/u",
    },
    trackOrder: {
        eyebrow: "// Seguimiento de pedido",
        title: "Rastrea tu pedido",
        subtitle: "Introduce tu referencia de pedido y el email usado en la compra para ver el estado en vivo.",
        refLabel: "Referencia del pedido",
        refPlaceholder: "NXP-XXXXXXXX",
        emailLabel: "Email",
        emailPlaceholder: "tu@ejemplo.com",
        submit: "Rastrear pedido",
        submitting: "Buscando…",
        notFound: "No se encontró ningún pedido con esa referencia y email. Verifica ambos e inténtalo de nuevo.",
        placedOn: "Realizado el {{date}}",
        itemsTitle: "Artículos",
        total: "Total",
        cancelled: "Este pedido fue cancelado.",
        stepPending: "Pendiente",
        stepConfirmed: "Confirmado",
        stepProcessing: "En proceso",
        stepShipped: "Enviado",
        stepDelivered: "Entregado",
        another: "Rastrear otro pedido",
    },
    auth: {
        loginEyebrow: "// Iniciar sesión",
        loginTitle: "Acceso investigador",
        loginWelcomeEyebrow: "// Bienvenido de nuevo",
        loginWelcomeLine1: "Accede a la",
        loginWelcomeLine2: "criocámara",
        loginWelcomeBody:
            "Inicia sesión para hacer seguimiento de pedidos, descargar Certificados de Análisis y acceder a precios investigador.",
        emailLabel: "Email",
        passwordLabel: "Contraseña",
        submitLogin: "Iniciar sesión",
        submittingLogin: "Autenticando…",
        newHere: "¿Nuevo aquí?",
        createAccount: "Crear una cuenta →",
        registerEyebrow: "// Crear cuenta",
        registerTitle: "Registro investigador",
        nameLabel: "Nombre completo",
        passwordMin: "Contraseña (≥6 caracteres)",
        submitRegister: "Crear cuenta",
        submittingRegister: "Creando cuenta…",
        alreadyRegistered: "¿Ya estás registrado?",
        signInLink: "Iniciar sesión →",
        registerConfirm:
            "Al registrarte confirmas que eres un investigador cualificado y reconoces que todos los compuestos se venden estrictamente para investigación in-vitro — no para consumo humano o veterinario.",
        memberBenefitsEyebrow: "// Beneficios para miembros",
        memberBenefitsLine1: "Únete a la",
        memberBenefitsLine2: "red",
        memberBenefits: [
            "· Historial de pedidos y archivo de COAs",
            "· Precio investigador (-15%)",
            "· Envío prioritario en cadena fría",
            "· Acceso anticipado a nuevos compuestos",
        ],
        accountEyebrow: "// Panel del investigador",
        hello: "Hola, {{name}}",
        signOut: "Cerrar sesión",
        ordersCount: "Pedidos",
        statStatus: "Estado",
        statSince: "Miembro desde",
        admin: "Administrador",
        verified: "Verificado",
        orderHistory: "Historial de pedidos",
        noOrders: "Aún no hay pedidos.",
        rowReference: "Referencia",
        reorder: "Repetir pedido",
        reordering: "Añadiendo…",
        reorderError: "No se pudo repetir el pedido — inténtalo de nuevo.",
        viewOrder: "Ver pedido",
        rowDate: "Fecha",
        rowItems: "Artículos",
        rowTotal: "Total",
    },
    faq: {
        eyebrow: "// Preguntas frecuentes",
        titleLine1: "Preguntas",
        titleLine2: "frecuentes",
        intro:
            "Respuestas a las dudas más comunes sobre pedidos, envíos, certificación de pureza y nuestra política de uso investigativo.",
        stillEyebrow: "// ¿Aún tienes dudas?",
        stillTitle: "Habla con el equipo técnico de nuestro laboratorio asociado",
        stillBody:
            "Para consultas específicas de compuesto o pedido, solemos responder en un día laborable.",
        contactUs: "Contáctanos",
        items: [
            {
                q: "¿Para qué se utilizan los productos de Nexus Peptides?",
                a: [
                    "Todos los productos listados en este sitio se venden estrictamente para fines de investigación de laboratorio in-vitro. Nuestros compuestos están destinados a investigadores cualificados en un entorno de laboratorio controlado y no son aptos para consumo humano o veterinario. No están destinados a diagnosticar, tratar, curar o prevenir ninguna enfermedad.",
                ],
            },
            {
                q: "¿Incluyen Certificado de Análisis (COA) con cada pedido?",
                a: [
                    "Sí. Cada lote se verifica de forma independiente por HPLC y espectrometría de masas, y hay un Certificado de Análisis completo disponible por lote. Las cuentas de investigador registradas pueden acceder al archivo de COAs junto con su historial de pedidos.",
                ],
            },
            {
                q: "¿Qué pureza tienen sus compuestos?",
                a: [
                    "Todos los compuestos se sintetizan en nuestro laboratorio asociado y se liberan sólo tras superar un protocolo QC de 6 etapas. La pureza mediana verificada es ≥99% por HPLC de fase inversa a 220 nm y 280 nm, con masa confirmada por LC-MS.",
                ],
            },
            {
                q: "¿Cómo se envían y almacenan los pedidos en tránsito?",
                a: [
                    "Los productos se envían liofilizados en viales de borosilicato desde nuestra cámara criogénica a −20°C, embalados en contenedores térmicos aislados con monitorización de cadena fría. El despacho es en 24 horas desde la confirmación del pedido y se envía por email un número de seguimiento en cuanto el paquete es recogido por la mensajería.",
                ],
            },
            {
                q: "¿Cuáles son las tarifas de envío?",
                a: [
                    "Envío gratuito a todo el mundo en pedidos superiores a £150. Por debajo: £15 Reino Unido, £20 UE y £30 resto del mundo. Los aranceles e impuestos de importación corren por cuenta del destinatario cuando corresponda.",
                ],
            },
            {
                q: "¿Cómo deben almacenarse los compuestos al llegar?",
                a: [
                    "Conservar los viales liofilizados a −20°C protegidos de la luz. La manipulación debe seguir las buenas prácticas de laboratorio para reactivos de investigación. Consulte siempre la ficha técnica del compuesto antes de usarlo en cualquier protocolo de investigación.",
                ],
            },
            {
                q: "¿Puedo solicitar un compuesto que no está en el catálogo?",
                a: [
                    "Sí. Nuestro catálogo es curado, pero nuestro laboratorio asociado puede obtener o sintetizar casi cualquier péptido de investigación bajo pedido. Utilice el formulario de contacto para describir lo que necesita — las peticiones por volumen y a medida reciben cotización en un día laborable.",
                ],
            },
        ],
    },
    bulk: {
        eyebrow: "// Volumen e institucional",
        titleLine1: "Cotización",
        titleLine2: "por volumen",
        intro:
            "¿Vas a hacer un pedido para un grupo de laboratorio, institución o programa de investigación? Cuéntanos qué necesitas y nuestro laboratorio asociado te devolverá una cotización — con plazos claros y precios por volumen — en un día laborable.",
        tiersEyebrow: "Precios por volumen",
        units: "unidades",
        leadTimesEyebrow: "Plazos",
        leadTimes: {
            standard: {
                label: "Estándar — en stock",
                desc: "Envío desde stock en cadena fría en 24h tras confirmación del pedido.",
            },
            priority: {
                label: "Lote prioritario",
                desc: "Lote reservado, controlado y despachado en 3–5 días laborables.",
            },
            flexible: {
                label: "Flexible / a medida",
                desc: "Síntesis a medida o reserva de gran lote — 2–4 semanas con actualizaciones por hitos.",
            },
        },
        institutionalEyebrow: "Cuentas institucionales",
        institutionalBody:
            "Universidades, hospitales y CROs pueden solicitar condiciones a 30 días, facturación por orden de compra y un contacto técnico dedicado en nuestro laboratorio asociado.",
        formTitle: "Solicitar cotización por volumen",
        name: "Nombre de contacto",
        institution: "Institución / laboratorio",
        email: "Email profesional",
        phone: "Teléfono",
        country: "País",
        leadTimeSelect: "Plazo preferido",
        compoundsLabel: "Compuestos y cantidades",
        compoundsHint: "Añade cada compuesto que necesites, con dosis opcional (p. ej. 5mg) y número de unidades.",
        compoundPlaceholder: "Nombre del compuesto (p. ej. BPC-157)",
        dosePlaceholder: "Dosis (opc.)",
        addCompound: "Añadir compuesto",
        removeRow: "Eliminar fila",
        totalUnits: "Unidades totales",
        notes: "Notas adicionales",
        notesPlaceholder: "Fechas de entrega, número de PO, detalles de secuencia a medida u otro contexto…",
        send: "Solicitar cotización",
        sending: "Enviando…",
        success: "Solicitud recibida. Nuestro laboratorio asociado responderá con precios y plazos en 1 día laborable.",
        errorNoItems: "Añade al menos un compuesto con cantidad.",
        prefilledFromCart: "Prellenado desde tu carrito — ajusta las cantidades según necesites.",
        cartAvailable_one: "Tienes 1 artículo en el carrito. ¿Importarlo como punto de partida?",
        cartAvailable_other: "Tienes {{count}} artículos en el carrito. ¿Importarlos como punto de partida?",
        loadFromCart: "Cargar del carrito",
    },

    about: {
        eyebrow: "// Sobre Nexus",
        titleLine1: "Encontramos",
        titleLine2: "el estándar",
        titleAccent: "que otros",
        titleLine3: "persiguen.",
        intro:
            "Nexus Peptides es distribuidor de compuestos de investigación premium. Colaboramos exclusivamente con un laboratorio de síntesis cuyos bioquímicos no transigen con la pureza — para que los investigadores obtengan la precisión molecular que necesitan para publicar datos que puedan defender.",
        standardsEyebrow: "// Estándares",
        standardsTitleLine1: "Cuatro compromisos.",
        standardsTitleLine2: "Cero concesiones.",
        commit: {
            molecular: { t: "Precisión molecular", d: "Síntesis en fase sólida con protección Fmoc, purificación RP-HPLC al 99%+." },
            verified: { t: "Verificación independiente", d: "Cada lote verificado de forma independiente por laboratorios de química analítica acreditados." },
            coldChain: { t: "Integridad de cadena fría", d: "Liofilizado a −80°C, enviado en contenedores aislados con monitorización térmica." },
            coa: { t: "COAs transparentes", d: "Cada producto se envía con un Certificado de Análisis completo. Sin datos ocultos." },
        },
        missionEyebrow: "// Misión",
        missionTitle: "Por qué existimos",
        missionBody1:
            "La investigación es tan sólida como sus reactivos. Un péptido defectuoso no sólo desperdicia tiempo — puede envenenar toda una literatura, enviando a otros laboratorios a perseguir fantasmas.",
        missionBody2:
            "Nexus existe para eliminar esa variable. Cada vial que sale de nuestro laboratorio asociado es una promesa silenciosa: los datos que produce son los datos que tu compuesto merece.",
        statsEyebrow: "// En cifras",
        stats: {
            founded: ["2019", "Fundada"],
            compounds: ["42", "Compuestos activos"],
            purity: ["≥99%", "Pureza mediana"],
            partners: ["1,2k+", "Socios de investigación"],
            qc: ["6", "Etapas QC por lote"],
            dispatch: ["24h", "Despacho cadena fría"],
        },
        ctaTitle: "Construye tu investigación con el estándar.",
        ctaExplore: "Ver catálogo →",
    },
    research: {
        eyebrow: "// Base de conocimiento",
        titleLine1: "Biblioteca",
        titleAccent: "de investigación",
        intro:
            "Literatura revisada por pares y documentos técnicos internos sobre los compuestos que sintetizamos. Actualizada continuamente por nuestro consejo asesor científico.",
        statsStudies: "Estudios indexados",
        statsCompounds: "Compuestos cubiertos",
        statsPartners: "Socios de investigación activos",
        partnershipEyebrow: "// Asociación de investigación",
        partnershipTitle: "Colabora con nuestro laboratorio asociado",
        partnershipBody:
            "Investigadores académicos e institucionales pueden solicitar nuestro programa de subvención de compuestos. Los proyectos elegibles reciben hasta un 50% de descuento sobre el precio de lista para estudios aprobados por IRB.",
        apply: "Solicitar programa",
    },
    contact: {
        eyebrow: "// Ponte en contacto",
        titleLine1: "Habla con",
        titleLine2: "nuestro laboratorio asociado.",
        intro:
            "Pedidos por volumen, preguntas técnicas, solicitudes de COA o colaboración en investigación — el equipo científico de nuestro laboratorio asociado responde en un día laborable.",
        infoEmail: "Email",
        infoPhone: "Teléfono",
        infoAddress: "Dirección del laboratorio",
        opsEyebrow: "Operaciones",
        ops:
            "Lunes – Viernes · 08:00 – 18:00 PT\nDespacho de cadena fría 24/7 para cuentas verificadas.",
        formTitle: "Enviar un mensaje",
        name: "Nombre",
        email: "Email",
        subject: "Asunto",
        message: "Mensaje",
        subjects: {
            general: "Consulta general",
            bulk: "Cotización por volumen",
            coa: "Solicitud de COA",
            collaboration: "Colaboración en investigación",
            press: "Prensa / Medios",
        },
        send: "Enviar mensaje",
        sending: "Enviando…",
        success: "Mensaje recibido. Nuestro equipo responderá en 1 día laborable.",
    },
    policy: {
        last: "Última actualización:",
        backHome: "← Volver al inicio",
    },
    ageGate: {
        eyebrow: "Verificación de edad",
        titleLine1: "¿Tienes 21 años",
        titleLine2: "o más?",
        body: "Para acceder al sitio debes confirmar que tienes al menos 21 años y que accedes al catálogo estrictamente para investigación de laboratorio in-vitro. Los productos de Nexus Peptides no son aptos para consumo humano o veterinario.",
        yes: "Sí — tengo 21 o más",
        no: "No — soy menor de 21",
        storedNote: "Tu selección se guarda localmente en este dispositivo.",
        deniedEyebrow: "Acceso restringido",
        deniedTitleLine1: "Lo sentimos —",
        deniedTitleLine2: "no puedes entrar.",
        deniedBody1: "Por restricciones legales y la normativa aplicable, debes tener ",
        deniedBodyEmphasis: "21 años o más",
        deniedBody2: " para comprar o navegar péptidos con fines de investigación. No tienes permitido acceder al sitio hasta cumplir el requisito mínimo de edad. Vuelve cuando lo hagas.",
        retryPrefix: "Si llegaste a esta pantalla por error, puedes ",
        retryLink: "volver y responder de nuevo",
        retrySuffix: ".",
    },
};
